export default {
  id: {
    dbKey: 'id',
    type: 'string',
    displayName: 'ID',
  },
  name: {
    dbKey: 'name',
    type: 'string',
    displayName: 'Module name',
  },
  version: {
    dbKey: 'version',
    type: 'string',
    displayName: 'Version',
  },
  app: {
    dbKey: 'app',
    type: 'string',
    displayName: 'App Id',
  },
  mock: {
    id: '',
    name: '',
    version: '',
    app: '',
  },
};
